export const VENUE_OWNER_ROLE: string = "venue_owner";
export const ATHLETE_ROLE: string = "athlete";
export const NO_ROLE: string = "no_role";
export const STAFF_ROLE: string = "staff";
export const ADMIN_ROLE: string = "admin";
